<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
            :src="require('../assets/logo2.png')"
            class="my-3"
            contain
            height="200"
        />
      </v-col>

      <v-col class="mb-4">
        <h2>
          ברוכים הבאים לאתר של אבישי נהרי
        </h2>
        <br>
        <p class="subheading font-weight-regular">
          באתר זה תוכלו לראות את כל הפרופילים שלי באתרים החברתיים ותוכלו להיכנס אליהם בקלות
          <br>
          ליחצו על הפרופיל אליו תרצו להגיע
        </p>
      </v-col>
      <v-col
          class="mb-5"
          cols="12"
      >
        <h2 class="headline font-weight-bold mb-3">
          הפרופילים שלי:
        </h2>

        <v-row justify="center">
          <a
              v-for="(profile, i) in profileList"
              :key="i"
              :href="profile.href"
              class="subheading mx-3 white--text"
              target="_blank"
          >
            <i :class="'fab fa-'+profile.text"></i>
          </a>
        </v-row>
      </v-col>
      <v-col class="mb-5" cols="12">
        <div>
          <p class="paragraph">
            <span>היי,</span>
            <br>
            <span>שמי אבישי נהרי, נשוי + 2.</span>
            <br>
            אני מכיר את עולם המחשבים כבר יותר מעשור
            <br>
            עשר שנים אני טכנאי מחשבים ובארבע שנים האחרונות גם מתכנת אפליקציות desktop ואפליקציות WEB.
            <br>
            מגיל קטן, עולם המחשבים קרץ לי, הטכנולוגיה תמיד הייתה מונחת שם בקרן זוית וחיכתה שאאסוף אותה, שאתייחס אליה.
            <br>
            הרצון והתשוקה להבין איך קופסת הברזל הזו עובדת, איך לחיצת כפתור פועלת בערה בי גם כשעבדתי במקצועות אחרים.
            <br>
            אני מאמין בעבודת כפיים בשינון וחזרה עד ההצלחה, וכשהיא מגיעה - אין הרגשה טובה ממנה.
            <br>
            <br>
            סיימתי קורס Fullstack במכללת JohnBryce סניף ירושלים. במסגרת הלימודים רכשתי מיומניות בתחומים הבאים:
            <br>
          <ul>
            <li>צד לקוח (Client): HTML, CSS Bootstrap, JavaScript</li>
            <li> ספריות (Frameworks):React ,Angular</li>
            <li>צד שרת (Server): node.js ,MySQL ,MongoDB, PHP</li>
          </ul>
          <br>
            בנוסף התמקצעתי בבוטקמפ של Flash{Dev} שם רכשתי מיומניות נוספות:
            <br>
          <ul>
            <li> HTML, CSS, JavaScript</li>
            <li>סיבוכיות</li>
            <li> ספריות (Frameworks):Vue.js, Vuetify, Quasar</li>
            <li>צד שרת (Server): FireBase</li>
          </ul>
          <p class="paragraph2">
            כמו – כן, הוכשרתי על ידי חברת Proceed לניהול פרויקטים במתודולוגיית Agile.
            <br>
            בתפקידי האחרון פיתחתי מערכות Access & VBA בסביבת SQL.
            <br>
            בעל ידע נרחב במערכות הפעלה Windows , Windows Server, Linux
            <br>
            יש לי היכרות עם מודל ה OSI ופרוטוקולי תקשורת: HTTP / S, TCP / IP, UDP, DNS
            <br>
            שואף למצוינות כמפתח Fullstack.
          </p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'HelloWorld',

  data: () => ({
    profileList: [
      {
        text: 'facebook',
        href: 'https://www.facebook.com/avishy.nahari',
      },
      {
        text: 'linkedin',
        href: 'https://www.linkedin.com/in/avishy-nahari-fullstack/',
      },
      {
        text: 'github',
        href: 'https://github.com/Avishy1980',
      },
      {
        text: 'whatsapp',
        href: 'https://api.whatsapp.com/send?phone=972528693039&text=%D7%9C%D7%99%D7%A6%D7%99%D7%A8%D7%AA%20%D7%A7%D7%A9%D7%A8%20%D7%91%D7%95%D7%95%D7%98%D7%A1%D7%90%D7%A4',
      },
    ],
  }),
}
</script>